<script>
  import Modal from "@components/shared/modal.svelte";
  import { get } from "@lib/requests";
  
  let { date = $bindable(null), onUpdate } = $props();

  let selectedIds = $state([]);
  let notes = $state("");
  let available = $state([]);

  let title = $derived(date ? `Garde du ${date.toLocaleDateString()}` : "Garde");

  $effect(() => {
    if (selectedIds.length === 0) notes = "";
  });
  
  async function fetchData() {
    if (!date) return;
    try {
      const response = await get(`/api/v1/duty_shifts/date?date=${date.toISOString()}`, { responseKind: "json" });
      const data = await response.json;
      selectedIds = data.selected.map((vet) => vet.id.toString());
      notes = data.notes || "";
      available = data.available;
    } catch (error) {
      console.error(error);
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    onUpdate?.(selectedIds, notes);
  }
  
</script>

<Modal bind:open={date} title={title} onClose={() => date = null}>
  {#await fetchData()}
    <p>Chargement...</p>
  {:then}
    
    <form id="duty-shift-form" onsubmit={handleSubmit}>
      <div class="form-items">
        <div class="form-item col-span-12">
          <label for="duty-shift-vets">Vétérinaires</label>

          <div id="duty-shift-vets" class="grid grid-cols-2 gap-2">
            <button
              type="button"
              class={`flex items-center justify-between gap-2 rounded-sm border px-3 py-2 text-smaller cursor-pointer transition ${selectedIds.length === 0 ? "border-teal-400 bg-teal-50/80 text-teal-700" : "border-gray-200 bg-white text-gray-600"}`}
              onclick={() => selectedIds = []}
            >
              <span>Aucune garde</span>
              {#if selectedIds.length === 0}
                <span class="text-teal-500">✓</span>
              {/if}
            </button>

            {#each available as vet (vet.id)}
              <label class="flex items-center justify-between gap-2 rounded-sm border border-gray-200 bg-white px-3 py-2 text-smaller text-gray-600 cursor-pointer transition has-[:checked]:border-teal-400 has-[:checked]:bg-teal-50/80 has-[:checked]:text-teal-700">
                <input type="checkbox" class="sr-only peer" name="vets[]" value={vet.id.toString()} bind:group={selectedIds} />
                <span>{vet.name}</span>
                <span class="hidden text-teal-500 peer-checked:inline-block">✓</span>
              </label>
            {/each}
          </div>
        </div>

        {#if selectedIds.length > 0}
          <div class="form-item col-span-12">
            <label for="duty-shift-notes">Notes</label>
            <textarea name="notes" id="duty-shift-notes" bind:value={notes}></textarea>
          </div>
        {/if}
      </div>
    </form>

  {:catch error}
    <p>Erreur: {error.message}</p>
  {/await}

  {#snippet footerButtons()}
    <button type="submit" class="button submit" form="duty-shift-form">Enregistrer</button>
  {/snippet}
  
</Modal>
